export default {
  "t-engagement-management": "活动管理",
  "t-engagement-overview": "活跃度概览",
  "t-overview": "概览",
  "t-device-model": "设备型号",
  "t-sn-range": "SN 区间",
  "t-start-number": "起始编号",
  "t-end-number": "结束编号",
  "t-complete-sn-range-required": "请输入完整的SN查询区间",
  "t-filter": "筛选",
  "t-activation-rate": "激活率",
  "t-online-rate": "在线率",
  "t-usage-rate": "使用率",
  "t-high-frequency-activity-rate": "高频活跃率",
  "t-silent-devices": "沉默设备",
  "t-activated-devices-count": "已激活 {count} 台",
  "t-devices-count": "{count} 台",
  "t-device-unit": "台",
  "t-compared-with-last-week": "较上周",
  "t-trend": "趋势",
  "t-trend-analysis": "趋势分析",
  "t-recent-7-days": "最近7天",
  "t-recent-30-days": "最近30天",
  "t-recent-7-days-metrics-trend": "近 7 天活跃指标走势",
  "t-recent-30-days-metrics-trend": "近 30 天活跃指标走势",
  "t-total-uptime": "在线累计时长",
  "t-total-uptime-list": "设备在线累计时长列表",
  "t-total-uptime-list-desc": "统计各设备与 TMS 累计保持连接的总时长及多信号活跃统计",
  "t-heartbeat-statistics": "心跳统计",
  "t-heartbeat": "心跳统计",
  "t-heartbeat-statistics-list": "设备活跃信号统计列表",
  "t-heartbeat-statistics-list-desc": "记录各设备多信号活跃明细（刷卡/流量，任一达标即算活跃）",
  "t-heartbeat-signal": "活跃信号",
  "t-card-swipe-count": "刷卡次数",
  "t-print-count": "打印次数",
  "t-print-distance": "打印距离",
  "t-business-traffic": "业务流量",
  "t-screen-on-duration": "亮屏时长",
  "t-active-time": "激活时间",
  "t-active-time-list": "设备激活时间列表",
  "t-active-time-list-desc": "记录各设备完成激活并首次上线的时间节点",
  "t-days-from-now": "距今",
  "t-days-ago": "{count} 天前",
  "t-inactive-device-alert": "沉默设备预警",
  "t-inactive-device-alert-list": "沉默设备预警列表",
  "t-inactive-device-alert-list-desc": "上月有活跃信号但本月无活跃信号且在线时长不足的设备",
  "t-idle-device-alert": "空转设备预警",
  "t-idle-device-alert-list": "空转设备预警列表",
  "t-idle-device-alert-list-desc": "空转设备预警列表和设备在线但统计周期内无任何活跃信号（L2 多信号 OR：刷卡/打印/流量/亮屏）",
  "t-idle-devices-total": "空转设备总数",
  "t-idle-days": "空转天数",
  "t-pending-activation": "未激活设备提醒",
  "t-pending-activation-list": "未激活设备提醒列表",
  "t-pending-activation-list-desc": "录入 TMS 系统后从未激活上线的设备，按录入天数排序（越久越需关注）",
  "t-pending-activation-total": "未激活设备总数",
  "t-threshold-settings": "阈值配置",
  "t-edit-threshold-settings": "编辑阈值配置",
  "t-threshold-settings-list": "阈值配置列表",
  "t-threshold-settings-list-desc": "管理系统中各类活跃度的判断阈值参数",
  "t-threshold-config-name": "配置名称",
  "t-threshold-type": "阈值类型",
  "t-threshold-value": "阈值",
  "t-threshold-type-online-duration": "在线时长",
  "t-threshold-type-silent-days": "沉默天数",
  "t-threshold-type-idle-detection": "空转检测",
  "t-threshold-type-card-swipe-count": "刷卡次数",
  "t-threshold-type-unactivated-days": "未激活天数",
  "t-threshold-type-screen-on-duration": "亮屏时长",
  "t-threshold-type-business-traffic": "流量",
  "t-online-duration-threshold": "在线时长阈值",
  "t-silent-device-threshold": "沉默设备阈值",
  "t-idle-device-threshold": "空转设备阈值",
  "t-high-frequency-active-threshold": "高频活跃阈值",
  "t-unactivated-reminder-threshold": "未激活提醒阈值",
  "t-screen-on-duration-threshold": "亮屏时长阈值",
  "t-business-traffic-threshold": "业务流量阈值",
  "t-threshold-value-24h": "24h",
  "t-threshold-value-7-days": "7天",
  "t-threshold-value-3-days": "3天",
  "t-threshold-value-50-times-day": "50次/天",
  "t-threshold-value-30-days": "30天",
  "t-threshold-value-2h": "2h",
  "t-threshold-value-10mb-day": "10MB/天",
  "t-online-duration-threshold-desc": "设备连续在线时长超过此值视为活跃",
  "t-silent-device-threshold-desc": "设备超过此天数无活跃信号视为沉默",
  "t-idle-device-threshold-desc": "设备在线但无业务行为超过此天数视为空转",
  "t-high-frequency-active-threshold-desc": "日刷卡次数超过此值视为高频活跃",
  "t-unactivated-reminder-threshold-desc": "设备录入后超过此天数未激活发出提醒",
  "t-screen-on-duration-threshold-desc": "日亮屏时长超过此值计入活跃信号",
  "t-business-traffic-threshold-desc": "日业务流量超过此值计入活跃信号",
  "t-pending-days": "录入天数",
  "t-activation-analytics": "激活分析",
  "t-activation-analytics-list": "合作伙伴激活分析",
  "t-activation-analytics-list-desc": "各合作伙伴设备激活情况一览，支持按激活率排序",
  "t-activation-analytics-total": "激活分析总数",
  "t-activation-rate-rank": "激活率",
  "t-partner-count": "合作伙伴数",
  "t-average-activation-rate": "平均激活率",
  "t-highest-activation-rate": "最高激活率",
  "t-lowest-activation-rate": "最低激活率",
  "t-network-devices": "在线设备",
  "t-activated": "已激活",
  "t-unactivated": "未激活",
  "t-entry-time": "录入时间",
  "t-inventory-estimation": "在库估算",
  "t-latest-heartbeat": "最近心跳",
  "t-suspected-in-inventory": "疑似在库",
  "t-long-term-not-powered-on": "长期未开机",
  "t-contact-partner-for-verification": "需联系合作伙伴核查",
  "t-idle-duration": "空转时长",
  "t-hour-unit": "h",
  "t-idle-over-72-hours": "空转 ≥72 小时",
  "t-idle-24-72-hours": "空转 24-72 小时",
  "t-idle-under-24-hours": "空转 <24 小时",
  "t-continuously-online-no-business": "持续在线无业务",
  "t-follow-up-business-opening-status": "需跟进业务开通状态",
  "t-possible-temporary-maintenance": "可能为临时维护",
  "t-current-online-status": "当前在线状态",
  "t-warning-level": "预警级别",
  "t-warning-high": "高",
  "t-warning-medium": "中",
  "t-warning-low": "低",
  "t-contact-merchant": "联系商户",
  "t-observe": "观察",
  "t-last-month-active-signal": "上月活跃信号",
  "t-this-month-active-signal": "本月活跃信号",
  "t-this-month-online-duration": "本月在线时长",
  "t-total-online": "累计在线",
  "t-last-active": "最后上线时间",
  "t-total-devices-count": "共 {count} 台设备",
  "t-silent-devices-total": "沉默设备总数",
  "t-risk-critical-days": "紧急（≥30天）",
  "t-risk-medium-days": "中等（14-29天）",
  "t-risk-watch-days": "观察（7-13天）",
  "t-suspected-fault-or-permanent-offline": "疑似故障或永久离线",
  "t-merchant-status-follow-up-needed": "需跟进商户状态",
  "t-continuous-monitoring": "持续监测中",
  "t-silent-days": "沉默天数",
  "t-day-unit": "天",
  "t-last-card-swipe-time": "上次刷卡时间",
  "t-risk-level": "风险等级",
  "t-risk-critical": "紧急",
  "t-risk-medium": "中等",
  "t-risk-watch": "观察",
  "t-follow-up": "跟进",
  "t-view-threshold-settings": "查看阈值配置",
  "t-close": "关闭",
  "t-fetch-failed": "获取数据失败",
  "t-save-success": "保存成功",
  "t-save-failed": "保存失败",
  "t-threshold-value-range": "阈值必须在 1-100 之间",
}
